export const timeOptionsTranslate = {
  day: 'Díario',
  hour: 'Hora',
  month: 'Mensual',
  year: 'Anual',
};
